import { configureStore } from "@reduxjs/toolkit";
import TabReducer from "./reducers/tab";
import ChatReducer from "./reducers/chat";
export default configureStore({
  reducer: {
    tab: TabReducer,
    chat: ChatReducer,
  },
});
